var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFinishedApplicant(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.1756 49.1286C37.5274 49.1286 48.3512 38.3048 48.3512 24.953C48.3512 11.6011 37.5274 0.777344 24.1756 0.777344C10.8238 0.777344 0 11.6011 0 24.953C0 38.3048 10.8238 49.1286 24.1756 49.1286Z",
    fill: "#68A395"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.15381 25.5427L14.2734 20.6971L21.3417 27.2071L35.2571 14.1133L40.3135 18.8957L21.2679 36.9722L9.15381 25.5427Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinishedApplicant);
export default __webpack_public_path__ + "static/media/finished-applicant.b3594318ad7f6dc8945f09da281a88b0.svg";
export { ForwardRef as ReactComponent };